import config from "../config/config";
import axios from "axios";

// Sign in with a 6-digit code emailed to the user instead of a password.
export const requestSignInCodeAPI = async (params) => {
  return await axios({
    method: "post",
    url: `${config.api.base_url}auth/sign-in-code/request`,
    data: params,
    headers: {
      "Content-type": "application/json; charset=UTF-8",
    },
  });
};

export const signInWithCodeAPI = async (params) => {
  return await axios({
    method: "post",
    url: `${config.api.base_url}auth/sign-in-code/verify`,
    data: params,
    headers: {
      "Content-type": "application/json; charset=UTF-8",
    },
  });
};
